import * as stylex from "@stylexjs/stylex";
import { breakpoints } from "./consts.stylex";

const fontFamily =
  "Noto Sans,Noto Sans SC,Noto Naskh Arabic,Verdana,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,PingFang SC,Microsoft YaHei,sans-serif";

export const typography = stylex.create({
  tera: {
    fontFamily,
    fontWeight: 400,
    fontStyle: "normal",
    // Non-overlapping ranges for the middle tiers: StyleX assigns the same specificity
    // to every conditional variant of a property, so 3+ open-ended min-width tiers on
    // one property don't reliably cascade by breakpoint size — only by source order,
    // which isn't guaranteed. Bounding the middle tiers to a max-width avoids the overlap.
    fontSize: {
      default: "48px",
      "@media (min-width: 600px) and (max-width: 899.98px)": "8.4vw",
      "@media (min-width: 900px) and (max-width: 1199.98px)": "9vw",
      [breakpoints.l]: "88px",
    },
    lineHeight: {
      default: "0.9",
      [breakpoints.m]: "1",
    },
  },
  heading4: {
    fontFamily,
    fontWeight: 700,
    fontStyle: "normal",
    fontSize: {
      default: "14px",
      [breakpoints.m]: "16px",
    },
    lineHeight: {
      default: "22px",
      [breakpoints.m]: "24px",
    },
  },
  heading2: {
    fontFamily,
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: {
      default: "18px",
      [breakpoints.m]: "24px",
    },
    lineHeight: {
      default: "24px",
      [breakpoints.m]: "32px",
    },
  },
  table: {
    fontFamily,
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: {
      default: "12px",
      [breakpoints.m]: "14px",
    },
    lineHeight: {
      default: "16px",
      [breakpoints.m]: "20px",
    },
  },
  meta: {
    fontFamily,
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: {
      default: "10px",
      [breakpoints.m]: "12px",
    },
    lineHeight: {
      default: "14px",
      [breakpoints.m]: "16px",
    },
  },
  axis: {
    fontFamily,
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "10px",
    lineHeight: "14px",
  },
  lead2: {
    fontFamily,
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: {
      default: "14px",
      [breakpoints.m]: "16px",
    },
    lineHeight: {
      default: "25px",
      [breakpoints.m]: "28px",
    },
  },
  heading3: {
    fontFamily,
    fontWeight: 700,
    fontStyle: "normal",
    fontSize: {
      default: "16px",
      [breakpoints.m]: "18px",
    },
    lineHeight: {
      default: "22px",
      [breakpoints.m]: "24px",
    },
  },
  body2: {
    fontFamily,
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: {
      default: "14px",
      [breakpoints.m]: "16px",
    },
    lineHeight: {
      default: "22px",
      [breakpoints.m]: "24px",
    },
  },
  body2Hero: {
    fontFamily,
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: {
      default: "14px",
      [breakpoints.m]: "16px",
    },
    lineHeight: {
      default: "24px",
      [breakpoints.m]: "28px",
    },
  },
  heading1: {
    fontFamily,
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: {
      default: "24px",
      [breakpoints.m]: "32px",
    },
    lineHeight: {
      default: "32px",
      [breakpoints.m]: "40px",
    },
  },
  heading1Bold: {
    fontFamily,
    fontWeight: 700,
    fontStyle: "normal",
    fontSize: {
      default: "24px",
      [breakpoints.m]: "32px",
    },
    lineHeight: {
      default: "32px",
      [breakpoints.m]: "40px",
    },
  },
  title: {
    fontFamily,
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: {
      default: "32px",
      [breakpoints.m]: "48px",
    },
    lineHeight: {
      default: "48px",
      [breakpoints.m]: "56px",
    },
  },
  button: {
    fontFamily,
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "20px",
  },
  footer: {
    fontFamily,
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "1rem",
    lineHeight: "1rem",
  },
  interpretation: {
    fontFamily,
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "14px",
    lineHeight: "20px",
  },
  lead1: {
    fontFamily,
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: {
      default: "16px",
      [breakpoints.m]: "18px",
    },
    lineHeight: {
      default: "25px",
      [breakpoints.m]: "28px",
    },
  },
  body2Alt: {
    fontFamily,
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: {
      default: "14px",
      [breakpoints.l]: "16px",
    },
    lineHeight: {
      default: "22px",
      [breakpoints.l]: "24px",
    },
  },
  body1: {
    fontFamily,
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: {
      default: "18px",
      [breakpoints.m]: "24px",
    },
    lineHeight: {
      default: "28px",
      [breakpoints.m]: "36px",
    },
  },
});
